import cx from 'classnames'
import styles from './finance-calculator-cta.module.css'
import { sendDigitalDataEvent } from '@cinch-nx/shared-analytics'
import { datadogRum } from '@datadog/browser-rum'
import { Actions, Context } from '@cinch-nx/data-search'
import { SvgIconFromSheet } from '@cinch-nx/search-ui-svg-icon-sheet'

export interface FinanceCalculatorCTAProps {
  href: string
  target: string
  rel: string | undefined
  vehicleId: string
}

const CalculatorIcon = () => (
  <SvgIconFromSheet size={16} name={'calculator16Icon'} />
)

const FinanceCalculatorCTA = ({
  href,
  target,
  rel,
  vehicleId,
}: FinanceCalculatorCTAProps) => {
  const FINANCE_CALC_ARIA_LABEL = 'Calculate your finance options'

  const handleTracking = () => {
    sendDigitalDataEvent({
      event: {
        category: 'link',
        label: 'Finance_Calculator',
        action: 'Vehicle_Card_Click',
        value: vehicleId,
        name: 'click',
      },
    })

    datadogRum.addAction(Actions.SEARCH_FINANCE_CALCULATOR_CTA_CLICKED, {
      service: Context.SEARCH_FINANCE_CALCULATOR_CTA,
      squad: Context.SQUAD,
      label: 'Finance Calculator',
      vehicleId: vehicleId,
    })
  }

  return (
    <a
      href={`${href}#monthly-finance`}
      target={target}
      rel={rel}
      aria-label={FINANCE_CALC_ARIA_LABEL}
      className={cx(styles['financeCta'])}
      onClick={handleTracking}
    >
      <CalculatorIcon />
      Finance quote
    </a>
  )
}

export default FinanceCalculatorCTA
